<template>
  <iframe
    id="iframe"
    :src="url"
    :style="{ height: viewportHeight }"
  />
  <!-- <div class="service-page">
    <header class="service-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>
        {{ $t('webindex.custserver') }}
      </h1>
      <button
        type="button"
        class="user-btn"
        @click="$router.push('/user')"
      >
        <img
          src="../images/user/my.png"
          alt=""
        >
      </button>
    </header>

    <main class="service-main">
      <section class="intro-card">
        <span class="intro-icon">
          <van-icon name="service-o" />
        </span>
        <div class="intro-copy">
          <strong>{{ $t('webindex.custwaiting') }}</strong>
          <p>{{ $t('webindex.worktime') }}</p>
        </div>
      </section>

      <section
        v-if="data"
        class="contact-card"
      >
        <a
          v-if="data.kefu"
          :href="data.kefu"
          target="_blank"
          class="contact-row"
        >
          <span class="contact-icon">
            <van-icon name="service-o" />
          </span>
          <span class="contact-info">
            <strong>{{ $t('webindex.custserver') }}</strong>
          </span>
          <span class="consult">{{ $t('webindex.chat') }}</span>
        </a>
        <a
          v-if="data.whats"
          :href="data.whats"
          target="_blank"
          class="contact-row"
        >
          <span class="contact-icon">
            <van-icon name="phone-circle-o" />
          </span>
          <span class="contact-info">
            <strong>Whatsapp</strong>
          </span>
          <span class="consult">{{ $t('webindex.chat') }}</span>
        </a>
        <a
          v-if="data.telgram"
          :href="data.telgram"
          target="_blank"
          class="contact-row"
        >
          <span class="contact-icon">
            <van-icon name="guide-o" />
          </span>
          <span class="contact-info">
            <strong>Telgram</strong>
          </span>
          <span class="consult">{{ $t('webindex.chat') }}</span>
        </a>
      </section>
    </main>
  </div> -->
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon } from 'vant';

Vue.use(Icon);

export default {
  name: 'Kefu',
  components: {},
  data() {
    return {
		url:'javascript:void(0)',
		handler: null,
		viewportHeight: '100vh',
		data: {},
    };
  },
  created() {
    this.$parent.footer('user');
  },
  mounted() {
  	this.updateViewportHeight();
  	window.addEventListener('resize', this.updateViewportHeight, { passive: true });
  	window.addEventListener('orientationchange', this.updateViewportHeight, { passive: true });
    this.start();
  },
  beforeDestroy() {
  	window.removeEventListener('resize', this.updateViewportHeight);
  	window.removeEventListener('orientationchange', this.updateViewportHeight);
  },
  methods: {
	updateViewportHeight() {
		if (window && window.innerHeight) {
			this.viewportHeight = (window.innerHeight-50) + 'px';
		}
	},
    start() {
      let agent = localStorage.getItem('agent');
      Fetch('/index/webconfig', {
        agent,
        type: 'web',
      }).then(res => {
        this.data = res.data;
		if(this.data.kefu){
			this.url = this.data.kefu;
		}
      });
    },
  },
};
</script>

<style lang="less" scoped>
.service-page {
  min-height: 100vh;
  padding-bottom: 18px;
  box-sizing: border-box;
  background: #f4f5fb;
  color: #061429;
}

.service-header {
  position: sticky;
  top: 0;
  z-index: 10;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f8fd;
}

.service-header h1 {
  margin: 0;
  color: #202637;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
}

.back-btn,
.user-btn {
  position: absolute;
  top: 10px;
  width: 28px;
  height: 28px;
  padding: 0;
  border: 0;
  background: transparent;
}

.back-btn {
  left: 8px;
  color: #071426;
  font-size: 22px;
}

.user-btn {
  right: 12px;
}

.user-btn img {
  display: block;
  width: 28px;
  height: 28px;
  object-fit: contain;
}

.service-main {
  padding: 16px 16px 88px;
}

.intro-card,
.contact-card {
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(30, 45, 82, .045);
}

.intro-card {
  min-height: 120px;
  display: grid;
  grid-template-columns: 48px minmax(0, 1fr);
  align-items: center;
  column-gap: 14px;
  padding: 18px 20px;
  box-sizing: border-box;
}

.intro-icon,
.contact-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.intro-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: linear-gradient(135deg, #6199ff 0%, #246cf2 100%);
  font-size: 24px;
}

.intro-copy {
  min-width: 0;
}

.intro-copy strong {
  display: block;
  color: #050b18;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.intro-copy p {
  margin: 8px 0 0;
  color: #8a93a3;
  font-size: 12px;
  line-height: 20px;
}

.contact-card {
  margin-top: 18px;
}

.contact-row {
  min-height: 70px;
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 14px;
  margin: 0 20px;
  color: #1f2b44;
  text-decoration: none;
  box-sizing: border-box;
}

.contact-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #70d87b 0%, #2fac59 100%);
  font-size: 18px;
}

.contact-info {
  min-width: 0;
}

.contact-info strong {
  display: block;
  overflow: hidden;
  color: #243049;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.consult {
  min-width: 64px;
  height: 30px;
  padding: 0 12px;
  border-radius: 15px;
  background: #3775f4;
  color: #fff;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  box-sizing: border-box;
}
#iframe {
	display: block;
	width: 100%;
	overflow-y:hidden;
	border: none;
	padding-bottom: 0;
}
</style>
